import React from 'react';
import {
  AGE_LIMIT,
  AgeRange,
  EthnicAppearance,
  FiltersNameEnum,
  GenderAppearance,
  Search,
  UnionStatus,
  WorkingLocations,
  SeekingRepresentation,
} from '@blocs.filter';
import { useTranslation } from '@blocs.i18n';
import styled from 'styled-components';
import { useFiltersLabel } from './useFilterLabels';

// We need to use the styled component here instad of className because
// the Search component has it written in styled components and that's higher priority than the class :(
const StyledSearch = styled(Search)`
  width: auto;
`;

export const FilterForm = () => {
  const { t } = useTranslation();
  const filtersLabel = useFiltersLabel();

  return (
    <>
      <StyledSearch name={FiltersNameEnum.stageName} label={t('common:form.title.stageName')} />
      <SeekingRepresentation
        name={FiltersNameEnum.seekingRepresentation}
        label={filtersLabel[FiltersNameEnum.seekingRepresentation]}
      />
      <UnionStatus
        unionStatusName={FiltersNameEnum.unionStatus}
        excludeUnionStatusName={FiltersNameEnum.excludeUnionStatus}
        label={filtersLabel[FiltersNameEnum.unionStatus]}
        className="cn_my-0 cn_m:my-1"
      />
      <GenderAppearance
        gender={{
          name: FiltersNameEnum.gender,
          label: filtersLabel[FiltersNameEnum.gender],
        }}
        additionallyIdentifiesAs={{
          name: FiltersNameEnum.additionallyIdentifiesAs,
          label: filtersLabel[FiltersNameEnum.additionallyIdentifiesAs],
        }}
        className="cn_my-0 cn_m:my-1"
      />
      <EthnicAppearance
        name={FiltersNameEnum.ethnicAppearance}
        label={filtersLabel[FiltersNameEnum.ethnicAppearance]}
      />
      <AgeRange
        ageRangeName={FiltersNameEnum.playableAgeRange}
        switchAgeToMonthsName={FiltersNameEnum.switchTo}
        ageMinName={FiltersNameEnum.min}
        ageMaxName={FiltersNameEnum.max}
        label={filtersLabel[FiltersNameEnum.playableAgeRange]}
        ageLimit={AGE_LIMIT}
      />
      <WorkingLocations name={FiltersNameEnum.workingLocation} label={filtersLabel[FiltersNameEnum.workingLocation]} />
    </>
  );
};
